import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { UserModel } from "../UserModel";
import { Moment } from "moment";
import * as sa from "Application";

class Request {
    public id: Guid | null = null;
    public firstName: string = "";
    public lastName: string = "";
    public emailAddress: string = "";
    public password: string = "";
    public concurrencyToken: string = "";
    public isDeleted: boolean = false;
    public lastLoginDate: Moment | null = null;
    public userRoles: string[] = [];
    public isAdminUser: boolean = false;
}

class Response {
    public id: Guid | null = null;
}

export class SaveUserEndpoint extends Endpoint<Request, Response> {
    constructor() {
        super();
        this.verb(Http.Put);
        this.path(`/api/user/upsert`);
    }

    HandleRequestAsync(model: UserModel): Promise<Request> {
        let request: Request = new Request();
        let userRoles: any[] = [];
        if (!Array.isArray(model.userRoles)) {
            userRoles.push(model.userRoles);
        }
        request.id = model.id;
        request.firstName = model.firstName;
        request.lastName = model.lastName;
        request.emailAddress = model.emailAddress;
        request.password = model.password;
        request.concurrencyToken = model.concurrencyToken;
        request.isDeleted = model.isDeleted;
        request.lastLoginDate = model.lastLoginDate;
        request.userRoles = userRoles ? userRoles : model.userRoles;
        request.isAdminUser = true;
        if (!request.id) {
            this.path("/api/account/register");
        }
        return Promise.resolve(request);
    }

    public async HandleResponseAsync(response: Response): Promise<UserModel> {
        let userModel: UserModel = new UserModel(response.id);
        userModel.fromResponse(response);
        return userModel;
    }
}
